import React, { useEffect, useState } from "react";
import styled from "styled-components";

import PretendardText from "../../../atoms/text/pretendardText";
import GrayBtn from "../../../atoms/button/grayBtn";
import Checkbox from "../../../atoms/input/checkbox";

import SelectBoxValue from "../../../organisms/selectBoxValue";
import MemberApi from "../../../../api/member.api";
import { errorHandler } from "../../../../util/errorHandler";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import ChangeMSGrades from "../../../organisms/user/userInfo/changeMSGrades";
import PointChange from "../../../organisms/user/userInfo/pointChange";
import WritableSet from "../../../organisms/user/userInfo/writableSet";

import OpenSet from "../../../organisms/user/userInfo/openSet";
import CouponGive from "../../../organisms/user/userInfo/couponGive";

const ListTopButtonGroup = ({
  style,
  setButtonGroupOpen,
  setAlarmPopupOpen,
  setSMSPopupOpen,
  getMemberList,
  normalGroupList,
  setSelectedGroupValue,
  userCheckedIdList,
  sessionStorageInit,
  selectedGroupId,
  initRoute,
}) => {
  // 그룹 유형 선택 관련
  const [buttonGroupFilterOpen, setButtonGroupFilterOpen] = useState({
    group: false,
    gradeAndLevel: false,
    point: false,
    coupon: false,
    read: false,
    write: false,
  });

  const [selectedGroupIdList, setSelectedGroupIdList] = useState([]);

  const createGroupFunc = async () => {
    try {
      let memberIdsTemp = userCheckedIdList.map((item) => item.id);

      if (Number(selectedGroupId) !== 0 && Number(selectedGroupId) !== -1) {
        if (
          !selectedGroupIdList.some((item) => item === Number(selectedGroupId))
        ) {
          const data01 = {
            memberIds: memberIdsTemp,
            groupIds: [selectedGroupId],
            isAdd: false,
          };

          await MemberApi.createGroup(data01);
        }
      }

      const data = {
        memberIds: memberIdsTemp,
        groupIds: selectedGroupIdList,
        isAdd: true,
      };

      await MemberApi.createGroup(data);
      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
      initRoute();
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (userCheckedIdList && userCheckedIdList.length === 1) {
      if (
        userCheckedIdList[0]?.groupList &&
        userCheckedIdList[0]?.groupList.length > 0
      ) {
        let temp = userCheckedIdList[0]?.groupList.map((group) => group.id);

        setSelectedGroupIdList(temp);
      }
    } else if (
      Number(selectedGroupId) !== 0 &&
      Number(selectedGroupId) !== -1
    ) {
      setSelectedGroupIdList([Number(selectedGroupId)]);
    } else {
      setSelectedGroupIdList([]);
    }
  }, [userCheckedIdList]);

  return (
    <div
      style={{
        width: "100%",
        height: 49,
        display: "flex",
        gap: 12,
        ...style,
      }}
    >
      {/* 버튼 그룹 - 그룹지정 */}
      <div
        style={{
          height: "fit-content",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <GrayBtn
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              group: !prev.group,
            }));
          }}
        >
          그룹지정
        </GrayBtn>
        {buttonGroupFilterOpen.group && (
          <FilterWrapper
            style={{
              width: 230,
              top: 36,
              padding: 16,
            }}
          >
            {normalGroupList.length > 0
              ? normalGroupList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 10,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (
                          selectedGroupIdList.some(
                            (item02) => item02 === item.id
                          )
                        ) {
                          let groupIdListTemp = selectedGroupIdList.filter(
                            (item02) => item02 !== item.id
                          );

                          setSelectedGroupIdList(groupIdListTemp);
                        } else {
                          setSelectedGroupIdList([
                            ...selectedGroupIdList,
                            item.id,
                          ]);
                        }
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "21.5px",
                          color: selectedGroupIdList.some(
                            (item02) => item02 === item.id
                          )
                            ? "rgba(181, 181, 181, 0.5)"
                            : "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      {selectedGroupIdList.some(
                        (item02) => item02 === item.id
                      ) && (
                        <img
                          src="/assets/admin/icons/ico_select_checked.svg"
                          alt="선택됨"
                          style={{
                            width: 18,
                            height: 18,
                          }}
                        />
                      )}
                    </div>
                  );
                })
              : null}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 10,
                borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
              }}
            >
              <PretendardText
                onClick={() => {
                  setSelectedGroupValue({
                    id: 0,
                  });
                }}
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  lineHeight: "21.5px",
                  color: "rgba(181, 181, 181, 0.5)",
                  cursor: "pointer",
                }}
              >
                새 그룹 만들기
              </PretendardText>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <GrayBtn
                style={{}}
                onClick={() => {
                  createGroupFunc();

                  setButtonGroupFilterOpen({
                    group: false,
                    gradeAndLevel: false,
                    point: false,
                    coupon: false,
                    read: false,
                    write: false,
                  });
                }}
              >
                적용
              </GrayBtn>
            </div>
          </FilterWrapper>
        )}
      </div>
      {/* 버튼 그룹 - 등급/레벨 변경 */}
      <div
        style={{
          height: "fit-content",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <GrayBtn
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              gradeAndLevel: !prev.gradeAndLevel,
            }));
          }}
        >
          등급/레벨 변경
        </GrayBtn>
        {buttonGroupFilterOpen.gradeAndLevel && (
          <ChangeMSGrades
            userCheckedIdList={userCheckedIdList}
            getMemberList={getMemberList}
            sessionStorageInit={sessionStorageInit}
            setButtonGroupOpen={setButtonGroupOpen}
            setButtonGroupFilterOpen={setButtonGroupFilterOpen}
          />
        )}
      </div>
      {/* 버튼 그룹 - 포인트 변경 */}
      <div
        style={{
          height: "fit-content",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <GrayBtn
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              point: !prev.point,
            }));
          }}
        >
          포인트 변경
        </GrayBtn>
        {buttonGroupFilterOpen.point && (
          <PointChange
            userCheckedIdList={userCheckedIdList}
            getMemberList={getMemberList}
            sessionStorageInit={sessionStorageInit}
            setButtonGroupOpen={setButtonGroupOpen}
            setButtonGroupFilterOpen={setButtonGroupFilterOpen}
          />
        )}
      </div>

      {/* 버튼 그룹 - 쿠폰 지급 */}
      <div
        style={{
          height: "fit-content",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <GrayBtn
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              coupon: !prev.coupon,
            }));
          }}
        >
          쿠폰 지급
        </GrayBtn>
        {buttonGroupFilterOpen.coupon && (
          <CouponGive
            userCheckedIdList={userCheckedIdList}
            getMemberList={getMemberList}
            sessionStorageInit={sessionStorageInit}
            setButtonGroupOpen={setButtonGroupOpen}
            setButtonGroupFilterOpen={setButtonGroupFilterOpen}
          />
        )}
      </div>
      {/* 버튼 그룹 - 열람 권한 */}
      <div
        style={{
          height: "fit-content",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <GrayBtn
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              read: !prev.read,
            }));
          }}
        >
          열람 권한
        </GrayBtn>
        {buttonGroupFilterOpen.read && (
          <OpenSet
            userCheckedIdList={userCheckedIdList}
            getMemberList={getMemberList}
            sessionStorageInit={sessionStorageInit}
            setButtonGroupOpen={setButtonGroupOpen}
            setButtonGroupFilterOpen={setButtonGroupFilterOpen}
          />
        )}
      </div>
      {/* 버튼 그룹 - 글쓰기 권한 */}
      <div
        style={{
          height: "fit-content",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <GrayBtn
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              write: !prev.write,
            }));
          }}
        >
          글쓰기 권한
        </GrayBtn>
        {buttonGroupFilterOpen.write && (
          <WritableSet
            userCheckedIdList={userCheckedIdList}
            getMemberList={getMemberList}
            sessionStorageInit={sessionStorageInit}
            setButtonGroupOpen={setButtonGroupOpen}
            setButtonGroupFilterOpen={setButtonGroupFilterOpen}
          />
        )}
      </div>
      <GrayBtn
        onClick={() => {
          setAlarmPopupOpen(true);
        }}
      >
        알림 보내기
      </GrayBtn>
      <GrayBtn
        onClick={() => {
          setSMSPopupOpen(true);
        }}
      >
        SMS 보내기
      </GrayBtn>
    </div>
  );
};

export default ListTopButtonGroup;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;
